import React from "react"
import { ButtonBase, ButtonProps } from "./ButtonBase"

export const ButtonTransparent = ({ className, ...props }: ButtonProps) => {
  return (
    <ButtonBase
      className={`text-foreground-base bg-transparent hover:bg-baseHover active:bg-border-base disabled:hover:bg-transparent ${className}`}
      {...props}
    />
  )
}
